'use client';

import { useAlert } from '@/contexts/AlertProvider';
import useAuth from '@/contexts/AuthProvider';
import useLoginModel from '@/contexts/LoginModelProvider';
import AroggaAPI from '@/services/ecommerce/apis/AroggaAPI';
import { API_ACCOUNT } from '@/services/ecommerce/apis/apiConstrant';
import cls from 'classnames';
import { useEffect, useState } from 'react';
import { BsHeartFill } from 'react-icons/bs';
const WishlistToggle = ({ globalData, variant }) => {
	const [reacted, setReacted] = useState(true);
	const [loading, setLoading] = useState(true);
	const { setShowLoginModal } = useLoginModel();
	const { isLogged } = useAuth();
	const [wishlistCount, setWishlistCount] = useState(0);

	const alert = useAlert();
	const toggleWishlist = async () => {
		if (!isLogged) {
			setShowLoginModal(true);
			return;
		}

		setReacted(!reacted);
		const { data, status, message } = await AroggaAPI.post(API_ACCOUNT.PRODUCT_WISHLIST_TOGGLE(variant.id));
		if (status === 'success') {
			if (reacted) {
				// Only decrement wishlistCount if it's greater than 0
				setWishlistCount(wishlistCount > 0 ? wishlistCount - 1 : 0);
			} else {
				setWishlistCount(wishlistCount + 1);
			}
			alert.success({
				title: reacted ? 'Removed' : 'Success',
				message: message,
				provider: 'toast'
			});
		}

		setLoading(false);
	};

	useEffect(() => {
		setReacted(globalData?.user_wishlist_product_exist);
		wishlistCount !== globalData?.ProductCountWishlist && setWishlistCount(globalData?.ProductCountWishlist);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [globalData]);

	return (
		<div
			className='d-flex gap-5 items-center'
			onClick={() => {
				setLoading(true);
				toggleWishlist();
			}}>
			<BsHeartFill
				className={cls('cursor-pointer', {
					'text-grey700': !reacted,
					'text-error': reacted
				})}
				size={20}
			/>
			<div className='text-grey600 fw-400'>{wishlistCount || 0}</div>
		</div>
	);
};

export default WishlistToggle;
